import CompaniesAdminTemplate from "components/templates/CompaniesAdminTemplate/CompaniesAdminTemplate";

const CompaniesAdminPage = () => {
  return <CompaniesAdminTemplate />;
};

export default CompaniesAdminPage;
